import Vue from 'vue'
import Vuex from 'vuex'
import * as getters from './getters'
import * as actions from './actions'
import * as mutations from './mutations'

Vue.use(Vuex)
//注册上面引入的各大模块
const store=new Vuex.Store({
  state:{
    promiseBtn:JSON.parse(localStorage.getItem(localStorage.getItem('userName')+'permission')),
    openTab:[],//所有打开的路由
    activeIndex:'/warn_index',//起始路由
    //控制菜单栏显影
    side_left:'',
    body_left:'',
    side_flag:false,
    //控制温度记录仪详情表单显影
    search_form_show:true,
    //控制库房管理页面canvas画布的标记位置
    // canvas_span_left:0,
    //全屏模式
    full_screen:false,
    full_screen_text:'全屏'
  },
  mutations:{
    //添加tabs
    add_tabs(state,data){
      this.state.openTab.push(data)
    },
    //删除tabs
    delete_tabs(state,route){
      let index=0
      for(let option of state.openTab){
        if(option.route===route){
          break;
        }
        index++
      }
      this.state.openTab.splice(index,1)
    },
    //设置当前激活的tab
    set_active_index(state,index){
      this.state.activeIndex=index
    }
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js